import ReactPaginate from "react-paginate";
import CommonCard from "../../components/ui/CommonCard/CommonCard";
import classes from "./Financial.module.css";
import { useEffect, useState } from "react";
import { useTheme } from "../../context/ThemeContext";
import useWindowDimensions from "../../hooks/getWindowDimensions";
import { RxCaretDown } from "react-icons/rx";
import { env } from "../../constants/env";
import axios from "axios";
import { formatDate } from "../../utilities/functions";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa6";
import CommonButton from "../../components/ui/CommonButton/CommonButton";
import AlertDialog from "../../components/ui/AlertDialog/AlertDialog";
import VerticalDotsIcon from "../../icons/VerticalDotsIcon";
import OutlinedButton from "../../components/ui/OutlinedButton/OutlinedButton";
import Table from "../../components/Table/Table";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import InputField from "../../components/ui/InputField/InputField";

const token = localStorage.getItem("token");

const manual = [
  {
    name: "John Doe",
    amount: "USD 100.00",
    accountNumber: "1234567890",
    status: "Pending",
    requestDate: "2024-11-24",
  },
  {
    name: "John Doe",
    amount: "USD 100.00",
    accountNumber: "1234567890",
    status: "Pending",
    requestDate: "2024-11-24",
  },
  {
    name: "John Doe",
    amount: "USD 100.00",
    accountNumber: "1234567890",
    status: "Pending",
    requestDate: "2024-11-24",
  },
  {
    name: "John Doe",
    amount: "USD 100.00",
    accountNumber: "1234567890",
    status: "Pending",
    requestDate: "2024-11-24",
  },
  {
    name: "John Doe",
    amount: "USD 100.00",
    accountNumber: "1234567890",
    status: "Pending",
    requestDate: "2024-11-24",
  },
  {
    name: "John Doe",
    amount: "USD 100.00",
    accountNumber: "1234567890",
    status: "Pending",
    requestDate: "2024-11-24",
  },
  {
    name: "John Doe",
    amount: "USD 100.00",
    accountNumber: "1234567890",
    status: "Pending",
    requestDate: "2024-11-24",
  },
  {
    name: "John Doe",
    amount: "USD 100.00",
    accountNumber: "1234567890",
    status: "Pending",
    requestDate: "2024-11-24",
  },
  {
    name: "John Doe",
    amount: "USD 100.00",
    accountNumber: "1234567890",
    status: "Pending",
    requestDate: "2024-11-24",
  },
  {
    name: "John Doe",
    amount: "USD 100.00",
    accountNumber: "1234567890",
    status: "Pending",
    requestDate: "2024-11-24",
  },
  {
    name: "John Doe",
    amount: "USD 100.00",
    accountNumber: "1234567890",
    status: "Pending",
    requestDate: "2024-11-24",
  },
  {
    name: "John Doe",
    amount: "USD 100.00",
    accountNumber: "1234567890",
    status: "Pending",
    requestDate: "2024-11-24",
  },
];

const auto = [
  {
    name: "Jane Doe",
    method: "Crypto (USDT -ERC20)",
    amount: "USD 100.00",
    accountNumber: "1234567890",
    status: "Approved",
    totalWithdrawal: "$100.00",
  },
  {
    name: "Jane Doe",
    method: "Crypto (USDT -ERC20)",
    amount: "USD 100.00",
    accountNumber: "1234567890",
    status: "Approved",
    totalWithdrawal: "$100.00",
  },
  {
    name: "Jane Doe",
    method: "Crypto (USDT -ERC20)",
    amount: "USD 100.00",
    accountNumber: "1234567890",
    status: "Approved",
    totalWithdrawal: "$100.00",
  },
  {
    name: "Jane Doe",
    method: "Crypto (USDT -ERC20)",
    amount: "USD 100.00",
    accountNumber: "1234567890",
    status: "Declined",
    totalWithdrawal: "$100.00",
  },
  {
    name: "Jane Doe",
    method: "Crypto (USDT -ERC20)",
    amount: "USD 100.00",
    accountNumber: "1234567890",
    status: "Approved",
    totalWithdrawal: "$100.00",
  },
  {
    name: "Jane Doe",
    method: "Crypto (USDT -ERC20)",
    amount: "USD 100.00",
    accountNumber: "1234567890",
    status: "Declined",
    totalWithdrawal: "$100.00",
  },
  {
    name: "Jane Doe",
    method: "Crypto (USDT -ERC20)",
    amount: "USD 100.00",
    accountNumber: "1234567890",
    status: "Declined",
    totalWithdrawal: "$100.00",
  },
  {
    name: "Jane Doe",
    method: "Crypto (USDT -ERC20)",
    amount: "USD 100.00",
    accountNumber: "1234567890",
    status: "Declined",
    totalWithdrawal: "$100.00",
  },
  {
    name: "Jane Doe",
    method: "Crypto (USDT -ERC20)",
    amount: "USD 100.00",
    accountNumber: "1234567890",
    status: "Approved",
    totalWithdrawal: "$100.00",
  },
  {
    name: "Jane Doe",
    method: "Crypto (USDT -ERC20)",
    amount: "USD 100.00",
    accountNumber: "1234567890",
    status: "Approved",
    totalWithdrawal: "$100.00",
  },
  {
    name: "Jane Doe",
    method: "Crypto (USDT -ERC20)",
    amount: "USD 100.00",
    accountNumber: "1234567890",
    status: "Approved",
    totalWithdrawal: "$100.00",
  },
];

const withDrawalrequest = [
  {
    title: "Request date",
    value: "2024-11-24",
  },
  {
    title: "User",
    value: "Jane Doe",
  },
  {
    title: "Method",
    value: "Crypto (USDT -ERC20)",
  },
  {
    title: "Wallet address",
    value: "0x7Ff5C5eE0C768FE3D...",
  },
  {
    title: "Status",
    value: "Approved",
  },
  {
    title: "Total withdrawal",
    value: "$100.00",
  },
];

const withDrawalrequestDeclined = [
  {
    title: "Request date",
    value: "2024-11-24",
  },
  {
    title: "User",
    value: "Jane Doe",
  },
  {
    title: "Method",
    value: "Crypto (USDT -ERC20)",
  },
  {
    title: "Wallet address",
    value: "0x7Ff5C5eE0C768FE3D...",
  },
  {
    title: "Status",
    value: "Declined",
  },
  {
    title: "Total withdrawal",
    value: "$100.00",
  },
  {
    title: "Reason",
    value: "Not enough funds",
  },
];

const Financial = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [activeTab, setActiveTab] = useState("Transactions");
  const [showDialog, setShowDialog] = useState();
  const [dialogContent, setDialogContent] = useState(null);
  const [withdrawals, setWithdrawals] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [processType, setProcessType] = useState("");
  const [error, setError] = useState("");
  const [selectedWithdrawal, setSelectedWithdrawal] = useState(null);
  const [withdrawalInfo, setWithdrawalInfo] = useState(null);
  const [showTableDialog, setShowTableDialog] = useState(false);
  const [reason, setReason] = useState("");
  const [transactions, setTransactions] = useState([]);

  const [operation, setOperation] = useState("");
  const [amount, setAmount] = useState("");
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(false);
  const [editAmount, setEditAmount] = useState("");

  const limit = 10;

  console.log("ARE WE GETTING ANYTHING ???", transactions);

  const switchTabs = ["Withdrawals", "Transactions"];

  //  useEffect(() => {
  //     if(activeTab === "Manual"){
  //       setRowsContent(manual)
  //     }else if(activeTab === "Auto"){
  //       setRowsContent(auto)
  //     }
  //   }, [activeTab])

  const fetchTransactions = async (pageNumber = 1) => {
    try {
      const res = await axios.get(
        `${env.apiUrl}/api/transactions?page=${pageNumber}&limit=${limit}`
      );
      setTransactions(res.data.data);
      setTotalPages(res.data.totalPages);
      setCurrentPage(res.data.page);
    } catch (error) {
      console.error("Error fetching transactions:", error);
    }
  };

  useEffect(() => {
    console.log("What is the current page", currentPage);
    if (activeTab === "Transactions") {
      fetchTransactions(currentPage);
    } else if (activeTab === "Withdrawals") {
      fetchWithdrawals(currentPage);
    }
  }, [currentPage]);

  useEffect(() => {
    // fetchWithdrawals("manual");
  }, []);

  useEffect(() => {
    if (activeTab === "Transactions") {
      fetchTransactions();
    } else if (activeTab === "Withdrawals") {
      fetchWithdrawals();
    }
  }, [activeTab]);

  console.log("SELECTED WITHDRAWAL", selectedWithdrawal);

  useEffect(() => {
    if (selectedWithdrawal !== null) {
      if (activeTab === "Transactions") {
        setWithdrawalInfo(transactions[selectedWithdrawal]);
      } else if (activeTab === "Withdrawals") {
        setWithdrawalInfo(withdrawals[selectedWithdrawal]);
      }
    }
  }, [selectedWithdrawal]);

  const fetchWithdrawals = async (processType, currentPage = 1) => {
    console.log("FETCHING WITHDRAWALS", processType);
    try {
      const response = await axios.get(
        `${env.apiUrl}/api/transactions/withdrawals`,
        {
          params: {
            page: currentPage,
            limit: 10,
          },
          headers: {
            Authorization: `Bearer ${token}`, // Add token to Authorization header
          },
        }
      );

      setWithdrawals(response.data.data);
      setTotalPages(response.data.totalPages);
      setCurrentPage(response.data.page);
      setError("");
    } catch (err) {
      setError(err.response?.data?.message || "Error fetching withdrawals");
    }
  };

  const handleAdd = async () => {
    if (!operation || !amount) {
      toast.error("Operation and amount are required.");
      return;
    }

    try {
      setLoading(true);

      const response = await axios.post(
        `${env.apiUrl}/api/transactions`,
        {
          type: operation,
          amount: parseFloat(amount),
          comment,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success("Transaction added successfully!");
      setShowDialog(false);
      setAmount(""); 
      setComment("");
      fetchTransactions();
    } catch (err) {
      console.error(err);
      toast.error("Failed to add transaction.");
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage.selected + 1);
    // fetchWithdrawals(processType, newPage);
  };

  const handleUpdateStatus = async (id, status) => {
    let declineReason = "";

    if (status === "declined") {
      declineReason = reason;
    }
    try {
      const response = await axios.patch(
        `${env.apiUrl}/api/withdraw/withdrawals/${id}`,
        { status, declineReason },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // Update the local state to reflect the new status
      // setWithdrawals((prevWithdrawals) =>
      //   prevWithdrawals.map((withdrawal) =>
      //     withdrawal.id === id ? { ...withdrawal, status: status } : withdrawal
      //   )
      // );
      fetchWithdrawals("manual");

      setShowDialog(false);
      setDialogContent(null);
      setShowTableDialog(false);

      toast.success(response.data.message);
    } catch (err) {
      toast.error(err.response?.data?.message || "Error updating status");
    }
  };

  const navigate = useNavigate();

  const columns = [
    { key: "name", label: "Name" },
    { key: "amount", label: "Amount" },
    { key: "accountNumber", label: "Account Number" },
    { key: "status", label: "Status" },
    { key: "requestDate", label: "Request Date" },
  ];

  const columns1 = [
    { key: "name", label: "Name" },
    { key: "amount", label: "Amount" },
    { key: "accountNumber", label: "Account Number" },
    { key: "status", label: "Status" },
    { key: "method", label: "Method" },
    { key: "type", label: "Type" },
    { key: "totalAmount", label: "Total Amount" },
    { key: "reason", label: "Comment" },
    // "id" is not included here, so it won't be displayed
  ];

  const handleUpdate = async (transactionId) => {
    try {
      const response = await fetch(
        `${env.apiUrl}/api/transactions/${transactionId}/amount`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ amount: parseFloat(editAmount) }),
        }
      );

      const result = await response.json();
      if (response.ok) {
        toast.success("Amount updated successfully!");
        if (activeTab === "Transactions") {
          fetchTransactions();
        } else if (activeTab === "Withdrawals") {
          fetchWithdrawals();
        }
        setEditAmount("")
        setShowDialog(false);
      } else {
        toast.error(result.error || "Failed to update amount.");
      }
    } catch (err) {
      console.error(err);
      toast.error("Server error");
    }
  };

  return (
    <div className={classes.wrapper}>
      {/* <div className="d-flex align-items-center justify-content-center">
        <InputField
          className={classes.searchInput}
          search={true}
          placeholder="Search users"
          onChange={handleSearch}
        />
      </div> */}
      <div className="d-flex align-items-center justify-content-between mt-3">
        <div className="d-flex align-items-center gap-4">
          <h3>Financial</h3>{" "}
          <div
            className={`${classes.switcherContainer} d-flex align-items-center gap-0`}
          >
            {switchTabs.map((item, i) => (
              <div
                key={i}
                className={`${classes.switchButton} ${
                  activeTab === item ? classes.activeButton : ""
                }`}
                onClick={() => {
                  setActiveTab(item);
                  fetchWithdrawals(
                    item === "Withdrawals" ? "manual" : "automated"
                  );
                }}
                role="button"
              >
                {item}
              </div>
            ))}
          </div>
        </div>
        <div className="d-flex align-items-center gap-4">
          <CommonButton
            title="Add entry"
            onClick={() => {
              setShowDialog(true);
              setDialogContent("addEntry");
            }}
          />
          <CommonButton
            title="See past requests"
            onClick={() => navigate("past-requests")}
          />
        </div>
      </div>

      <CommonCard className={`${classes.tableCard} mt-4`}>
        <Table
          showDialog={showTableDialog}
          setShowDialog={(value) => setShowTableDialog(value)}
          data={activeTab === "Withdrawals" ? withdrawals : transactions}
          dataType={activeTab}
          editItem={() => {
            setShowDialog(true);
            setDialogContent("edit-item");
          }}
          onClick={() => {
            setShowDialog(true);
            setDialogContent(null);
          }}
          decline={() => {
            setShowDialog(true);
            setDialogContent("decline");
          }}
          approve={() => {
            console.log("APPROVE CLICKED");
            handleUpdateStatus(withdrawalInfo._id, "approved");
          }}
          columns={activeTab === "Withdrawals" ? columns : columns1}
          clickedIndex={(index) => setSelectedWithdrawal(index)}
        />

        <AlertDialog
          isOpen={showDialog}
          onClose={() => {setShowDialog(false); setEditAmount(""); setAmount(""); setComment("");}}
          centerCard={true}
          titleText={
            dialogContent === "addEntry"
              ? "Add new entry"
              : dialogContent === "edit-item"
              ? "Edit record"
              : dialogContent === "decline"
              ? "Reason for decline"
              : "Withdrawal request"
          }
          showCloseIcon={dialogContent !== "decline"}
          style={{
            left: `calc(50vw - ${
              dialogContent === "decline" ? "125px" : "225px"
            })`,
          }}
        >
          {dialogContent === "addEntry" ? (
            <div className={`${classes.addEntryContainer} p-3`}>
              <div className="d-flex align-items-center gap-2 mb-2">
                <span>Operation:</span>
                <InputField
                  options={[
                    { value: "refund", label: "Refund" },
                    { value: "hedge cover", label: "Hedge cover" },
                  ]}
                  value={operation}
                  onChange={(e) => setOperation(e.target.value)}
                />
              </div>

              <div className="d-flex align-items-center gap-2 mb-2">
                <span>Amount:</span>
                <InputField
                  type="number"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                />
                USD
              </div>

              <div className="d-flex align-items-center gap-2 mb-2">
                <span>Comment:</span>
                <InputField
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                />
              </div>

              <div className="d-flex align-items-center justify-content-between w-100 mt-4 mb-2">
                <CommonButton
                  title="Cancel"
                  className={classes.cancelButton}
                  onClick={() => {setShowDialog(false); setAmount(""); setComment("")}}
                />
                <CommonButton
                  title={loading ? "Adding..." : "Add"}
                  onClick={handleAdd}
                  disabled={loading}
                />
              </div>
            </div>
          ) : dialogContent === "decline" ? (
            <div className={classes.declinedContainer}>
              <input
                type="text"
                placeholder="Enter reason"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
              />
              <div className="row mt-3">
                <div className="col-6">
                  <CommonButton
                    title="Cancel"
                    className={classes.cancelButton}
                    onClick={() => setShowDialog(false)}
                  />
                </div>
                <div className="col-6">
                  <button
                    className={classes.declineButton}
                    onClick={() =>
                      handleUpdateStatus(withdrawalInfo._id, "declined")
                    }
                  >
                    Decline
                  </button>
                </div>
              </div>
            </div>
          ) : dialogContent === "edit-item" ? (
            <div className={classes.declinedContainer}>
              <input
                type="number"
                placeholder="Enter amount"
                value={editAmount}
                onChange={(e) => setEditAmount(e.target.value)}
              />
              <div className="row mt-3">
                <div className="col-6">
                  <CommonButton
                    title="Cancel"
                    className={classes.cancelButton}
                    onClick={() => { setShowDialog(false); setEditAmount("") }}
                  />
                </div>
                <div className="col-6">
                  <button
                    className={classes.declineButton}
                    onClick={() => handleUpdate(withdrawalInfo._id)}
                  >
                    Update
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <>
              <div className={`row ${classes.contentSection}`}>
                {withDrawalrequest.map((item, i) => (
                  <div className="col-6 mb-3" key={i}>
                    <div className={classes.titleText}>{item.title}</div>
                    <div
                      className={`${classes.valueText} ${
                        item.value === "Approved"
                          ? classes.successText
                          : item.value === "Declined" && classes.dangerText
                      }`}
                    >
                      {item.value}
                    </div>
                  </div>
                ))}
              </div>
              <div className={classes.bottomSection}>
                <div className="d-flex flex-column gap-2">
                  <p className={classes.successText}>Payout was done</p>
                  <a href="#">Tx hash</a>
                  <p className={classes.dateText}> Dec 10, 10:00PM</p>
                </div>
              </div>
            </>
          )}
        </AlertDialog>
        <ReactPaginate
          previousLabel={<FaChevronLeft />} // React Icon for left arrow
          nextLabel={<FaChevronRight />} // React Icon for right arrow
          breakLabel={"..."}
          breakClassName={"break-me"}
          pageCount={totalPages}
          marginPagesDisplayed={2}
          pageRangeDisplayed={1}
          onPageChange={handlePageChange}
          containerClassName={"pagination"}
          subContainerClassName={"pages pagination"}
          previousLinkClassName={`page-link ${
            currentPage === 1 ? "disabled" : ""
          }`}
          nextLinkClassName={`page-link ${
            currentPage === totalPages ? "disabled" : ""
          }`}
          activeClassName={"active"}
        />
      </CommonCard>
    </div>
  );
};

export default Financial;
